module.exports = __webpack_public_path__ + "static/media/jira.ca359797.png";